import { Routes } from '@angular/router';

export const networkRoutes: Routes = [
  {
    path: 'nodes',
    loadComponent: () =>
      import('./nodes/components/dt-nodes/dt-nodes.component').then(
        (m) => m.DtNodesComponent,
      ),
  },
  {
    path: 'gateways-lorawan',
    loadComponent: () =>
      import(
        './gateways-lorawan/components/dt-gateways-lorawan/dt-gateways-lorawan.component'
      ).then((m) => m.DtGatewaysLorawanComponent),
  },
  {
    path: 'routers',
    loadComponent: () =>
      import('./routers/components/dt-routers/dt-routers.component').then(
        (m) => m.DtRoutersComponent,
      ),
  },
];
